var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconuser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0026 40.7493C49.2074 40.7493 56.6693 33.2874 56.6693 24.0827C56.6693 14.8779 49.2074 7.41602 40.0026 7.41602C30.7979 7.41602 23.3359 14.8779 23.3359 24.0827C23.3359 33.2874 30.7979 40.7493 40.0026 40.7493Z",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0342 53.2167L52.2341 65.0169C51.7674 65.4835 51.3341 66.3501 51.2341 66.9834L50.6008 71.4833C50.3674 73.1167 51.5008 74.25 53.1341 74.0167L57.634 73.3834C58.2674 73.2834 59.1675 72.8501 59.6008 72.3834L71.4007 60.5835C73.4341 58.5501 74.4007 56.1834 71.4007 53.1834C68.4341 50.2167 66.0675 51.1834 64.0342 53.2167Z",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3359 54.916C63.3359 58.516 66.1358 61.3159 69.7358 62.3159",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3672 74.0833C11.3672 61.1833 24.2006 50.75 40.0006 50.75C43.4673 50.75 46.8005 51.25 49.9005 52.1833",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconuser);
export default __webpack_public_path__ + "static/media/iconuser.5fb1f4412e9a19ceeb56852b1f70524b.svg";
export { ForwardRef as ReactComponent };